export default __webpack_public_path__ + "static/media/bb.a1c1729b.jpg";